<template>
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="7" cy="7" r="5"/><line x1="11" y1="11" x2="15" y2="15"/>
  </svg>
</template>
